import { SELECTION_ACTIONS } from './consts';
import { SelectionAction, SelectionState } from './types';
import { toggleAllInSet, toggleInSet } from './utils';

export const initialSelectionState: SelectionState = {
  selectedIds: new Set(),
  expandedOrgs: new Set(),
};

export function selectionReducer(
  state: SelectionState,
  action: SelectionAction,
): SelectionState {
  switch (action.type) {
    case SELECTION_ACTIONS.TOGGLE_REPO:
      return {
        ...state,
        selectedIds: toggleInSet(state.selectedIds, action.id),
      };
    case SELECTION_ACTIONS.TOGGLE_PROJECT_REPOS:
      return {
        ...state,
        selectedIds: toggleAllInSet(state.selectedIds, action.ids),
      };
    case SELECTION_ACTIONS.TOGGLE_ORG_REPOS:
      return {
        ...state,
        selectedIds: toggleAllInSet(state.selectedIds, action.ids),
      };
    case SELECTION_ACTIONS.SET_EXPANDED_ORGS:
      return { ...state, expandedOrgs: new Set(action.names) };
    case SELECTION_ACTIONS.SELECT_ALL_REPOS:
      return { ...state, selectedIds: new Set(action.ids) };
    default:
      return state;
  }
}
